import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from './safe.pipe';
import { RouterPipe } from '../shared/router.pipe';
import { NgxtForDirective } from '../directives/ngxt-for.directive';
import { HtmlDecodePipe } from './html-decode.pipe';

@NgModule({
  declarations: [
    SafePipe,
    RouterPipe,
    HtmlDecodePipe,
    NgxtForDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SafePipe,
    RouterPipe,
    HtmlDecodePipe,
    NgxtForDirective
  ],
  providers: [
    RouterPipe,
    HtmlDecodePipe
  ]
})
export class SharedModule { }
